import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { applySeo } from '@/lib/seo';
import { applySchema } from '@/lib/seoSchema';

export default function SeoManager() {
  const location = useLocation();

  useEffect(() => {
    applySeo(location.pathname);
    applySchema(location.pathname);
  }, [location.pathname]);

  return null;
}